import type { ReactNode, RefObject } from 'react';
import { formatCurrencyWithCommas } from '@/utils/formatNumber';
import { RightSectionWrapper } from './RightSectionWrapper';

export function SingleMonthlyPremium({
    rowRef,
    rightSection,
    rightRef,
    isRightWrapped,
    isFamilyPlan,
    premiumNumber,
}: {
    rowRef: RefObject<HTMLDivElement | null>;
    rightSection?: ReactNode;
    rightRef: RefObject<HTMLDivElement | null>;
    isRightWrapped: boolean;
    isFamilyPlan: boolean;
    premiumNumber: number | null;
}) {
    return (
        <div className="w-full rounded-2xl">
            <div
                ref={rowRef}
                className="flex flex-col items-stretch justify-start gap-3 lg:flex-row lg:flex-wrap lg:items-start lg:justify-start lg:gap-4"
            >
                <div className="flex w-full min-w-0 flex-row items-center justify-between gap-3 md:justify-start md:gap-5 lg:w-auto lg:shrink-0 lg:justify-start">
                    <div className="relative flex h-[50px] md:h-[35px] lg:h-[43px] w-[160px] items-center justify-center px-4 rounded-lg bg-white shrink-0 md:w-auto md:min-w-[140px]">
                        <div
                            style={{
                                position: 'absolute',
                                inset: 0,
                                padding: 1,
                                borderRadius: 8,
                                background: 'linear-gradient(143.77deg, #0277E0 0%, #1357B0 101.42%)',
                                WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                                WebkitMaskComposite: 'xor',
                                maskComposite: 'exclude',
                                pointerEvents: 'none',
                            }}
                        />
                        <span className="relative w-full min-w-0 truncate text-center text-base font-medium text-primary-500 sm:text-lg tabular-nums">
                            {premiumNumber != null && premiumNumber > 0 ? formatCurrencyWithCommas(premiumNumber) : '—'}
                        </span>
                    </div>
                    <div className="w-full min-w-0 text-base font-medium text-right leading-tight text-gray-800 md:w-auto md:text-left md:shrink-0 md:whitespace-nowrap lg:w-auto lg:shrink-0 lg:whitespace-nowrap">
                        {isFamilyPlan ? 'Family Monthly Premium' : 'Monthly Premium'}
                    </div>
                </div>

                <RightSectionWrapper
                    rightSection={rightSection}
                    rightRef={rightRef}
                    isRightWrapped={isRightWrapped}
                    variant="single"
                />
            </div>
        </div>
    );
}

